export default __webpack_public_path__ + "static/media/TobyFlenderson.dbe51de9.jpg";